import React from 'react';
import Logo from './Logo';
import { NavLink, useLocation } from 'react-router-dom';
import { BsFacebook, BsInstagram, BsTwitter } from 'react-icons/bs';

function Footer() {
	const location = useLocation();

	return (
		<footer>
			{/* Mobile Footer */}
			<div className='mt-auto flex flex-col items-center gap-10 bg-primary p-4 text-base-100 md:hidden'>
				<div className='flex items-center gap-3'>
					<Logo height={'h-12'} />
					<h2 className='font-heading text-xl text-base-100'>
						Marshall <br></br> Academy of the Arts <br></br> Vocal Music
					</h2>
				</div>
				<div className='flex gap-5 text-accent'>
					<a href='/'>
						<BsFacebook size='2em' />
					</a>
					<a href='/'>
						<BsInstagram size='2em' />
					</a>
					<a href='/'>
						<BsTwitter size='2em' />
					</a>
				</div>
				<div className='h-0.5 w-2/3 bg-base-100'></div>
				<div className='flex flex-col gap-5'>
					<div className='flex flex-col'>
						<span className='text-lg font-semibold text-accent'>
							Jeremy Padrones
						</span>
						<span>Phone</span>
						<span>Email Address</span>
					</div>
					<div className='flex flex-col'>
						<span className='text-lg font-semibold text-accent'>
							Marshall Academy of the Arts
						</span>
						<span>1515 Hughes Way, Long Beach, CA 90810</span>
						<span>lbmarshall.schoollop.com</span>
					</div>
				</div>
				<div className='h-0.5 w-2/3 bg-base-100'></div>
				<div className='flex gap-5 font-bold'>
					<NavLink
						to='/'
						className={location.pathname === '/' && 'text-accent'}
					>
						Home
					</NavLink>
					<NavLink
						to='/about'
						className={location.pathname === '/about' && 'text-accent'}
					>
						About
					</NavLink>
					<NavLink
						to='/calendar'
						className={location.pathname === '/calendar' && 'text-accent'}
					>
						Calendar
					</NavLink>
					<NavLink
						to='/families'
						className={location.pathname === '/families' && 'text-accent'}
					>
						Families
					</NavLink>
					<NavLink
						to='/gallery'
						className={location.pathname === '/gallery' && 'text-accent'}
					>
						Gallery
					</NavLink>
				</div>
				<div className='h-0.5 w-2/3 bg-base-100'></div>
				<div className='flex flex-col items-center text-center'>
					<div>
						Design by{' '}
						<a className='text-accent' href='https://www.nicoletodesign.com/'>
							Nicole To Design
						</a>
					</div>
					<div>
						Development by{' '}
						<a className='text-accent' href='https://blakelarson.dev/'>
							Blakelarson.dev
						</a>
					</div>
					<div className='mt-5 flex flex-col'>
						<span>Copyright © 2022</span>
						<span>Marshall Academy of the Arts Vocal Music. </span>
					</div>
				</div>
			</div>
			{/* Regular Footer */}
			<div className='mt-auto hidden flex-col items-center bg-primary p-10 text-base-100 md:flex md:gap-10'>
				<div className='flex gap-10 lg:gap-40'>
					<div className='flex flex-col gap-10'>
						<div className='flex items-center gap-10'>
							<Logo height={'h-32'} />
							<h2 className='font-heading text-xl text-base-100'>
								Marshall <br></br> Academy of the Arts <br></br> Vocal Music
							</h2>
						</div>
						<div className='flex gap-10 lg:gap-40'>
							<div className='flex flex-col'>
								<span className='text-lg font-semibold text-accent'>
									Jeremy Padrones
								</span>
								<span>Phone</span>
								<span>Email Address</span>
							</div>
							<div className='flex flex-col'>
								<span className='text-lg font-semibold text-accent'>
									Marshall Academy of the Arts
								</span>
								<span>1515 Hughes Way, Long Beach, CA 90810</span>
								<span>lbmarshall.schoollop.com</span>
							</div>
						</div>
						<div className='flex gap-5 text-accent'>
							<a href='https://www.facebook.com/groups/213383565765758/'>
								<BsFacebook size='2em' />
							</a>
							<a href='https://www.instagram.com/marshallacademymusic/'>
								<BsInstagram size='2em' />
							</a>
							<a href='https://twitter.com/lbmamb?s=20&t=D_LKbpETEtZQqtQhnrPqIw'>
								<BsTwitter size='2em' />
							</a>
						</div>
					</div>

					<div className='flex flex-col gap-5 font-bold'>
						<NavLink
							to='/'
							className={location.pathname === '/' && 'text-accent'}
						>
							Home
						</NavLink>
						<NavLink
							to='/about'
							className={location.pathname === '/about' && 'text-accent'}
						>
							About
						</NavLink>
						<NavLink
							to='/calendar'
							className={location.pathname === '/calendar' && 'text-accent'}
						>
							Calendar
						</NavLink>
						<NavLink
							to='/families'
							className={location.pathname === '/families' && 'text-accent'}
						>
							Families
						</NavLink>
						<NavLink
							to='/gallery'
							className={location.pathname === '/gallery' && 'text-accent'}
						>
							Gallery
						</NavLink>
					</div>
				</div>

				<div className='flex flex-col items-center text-center'>
					<div className='flex gap-5'>
						<span>
							Design by{' '}
							<a className='text-accent' href='https://www.nicoletodesign.com/'>
								Nicole To Design
							</a>
						</span>
						<span>
							Development by{' '}
							<a className='text-accent' href='https://blakelarson.dev/'>
								Blakelarson.dev
							</a>
						</span>
					</div>
					<div className='mt-3'>
						<span>
							Copyright © 2022 Marshall Academy of the Arts Vocal Music.{' '}
						</span>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
